import { createIcon } from '../createIcon.tsx';

export const SplitViewIcon = createIcon(
	'SplitViewIcon',
	<>
		{/* Rectangle split vertically */}
		<rect x="3" y="3" width="18" height="18" rx="2" />
		<line x1="12" y1="3" x2="12" y2="21" />
	</>,
);
